import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

import { TeamMemberAuthHeader, TeamMemberAuthColumn } from '../molecules/TeamMemberAuthColumn';

import ScrollImage from '../../static/image/scroll_hint.png';
import { TeamMemberListFragment, TeamMemberRole } from '../../gen/graphql';
import { CurrentUserFragment as User } from '../../gen/graphql';
import Pagination from './Pagination';
import { FETCH_LIMIT_LOW } from '../../const/Page';

interface Props {
  user: User;
  teamMembers: TeamMemberListFragment[];
  total: number;
  page: number;
  setPage: (page: number) => void;
  permissionCheck: (functionType: string, permissionType: string) => boolean;
  changeRole: (id: string, role: TeamMemberRole) => void;
  openExcludeModal: (id: string) => void;
}

export const TeamMemberAuthList: React.FC<Props> = ({
  user,
  teamMembers,
  total,
  page,
  setPage,
  permissionCheck,
  changeRole,
  openExcludeModal,
}) => {
  const [displayHint, setDisplayHint] = React.useState(true);

  return (
    <Container onClick={() => setDisplayHint(false)} onScroll={() => setDisplayHint(false)}>
      <TeamMemberAuthHeader />
      {teamMembers.map((teamMember) => (
        <TeamMemberAuthColumn
          key={teamMember.id}
          user={user}
          teamMember={teamMember}
          permissionCheck={permissionCheck}
          changeRole={changeRole}
          openExcludeModal={openExcludeModal}
        />
      ))}
      <StyledPagination total={total} perPage={FETCH_LIMIT_LOW} page={page} setPage={setPage} />
      <Scroll src={ScrollImage} isDisplay={displayHint} alt="" />
    </Container>
  );
};

const Container = styled.div`
  position: relative;

  ${media.lessThan('large')`
    overflow-x: auto;
  `}

  ${media.lessThan('medium')`
    margin: 0 -1rem;
    padding: 0 1rem;
  `}
`;
const Scroll = styled.img<{ isDisplay: boolean }>`
  display: none;
  max-width: 10rem;
  max-height: 100%;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  ${(props) =>
    props.isDisplay &&
    media.lessThan('medium')`
    display: block;
  `}
`;

const StyledPagination = styled(Pagination)`
  margin: 2rem auto 0;
`;
